export const formats = ['hex','rgba','hsla', 'cmyk']